"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBasketOutcomeName = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const i18next_1 = __importDefault(require("i18next"));
const bets_1 = require("../bets");
const events_1 = require("../events");
const outcomeHasParams_1 = require("./outcomeHasParams");
const getScoreName_1 = require("./getScoreName");
const getBasketOutcomeName = ({ probWithOutcome, event, isBetOutcome = false, outcomeCategory, }) => {
    const prefix = outcomeCategory ? `${outcomeCategory === null || outcomeCategory === void 0 ? void 0 : outcomeCategory.name}. ` : '';
    let name = `${prefix}`;
    if (isBetOutcome) {
        name += getBetOutcomeName(probWithOutcome, event);
    }
    else {
        name += getOutcomeName(probWithOutcome, event);
    }
    if ((0, outcomeHasParams_1.outcomeHasParams)(probWithOutcome, betweb_openapi_axios_1.ParameterType.HomeScore, betweb_openapi_axios_1.ParameterType.AwayScore)) {
        name = `${prefix} ${(0, getScoreName_1.getScoreName)(probWithOutcome)}`;
    }
    const omitValueParameter = outcomeHasMarketLink(probWithOutcome, betweb_openapi_axios_1.MarketLink.TotalOver, betweb_openapi_axios_1.MarketLink.TotalUnder, betweb_openapi_axios_1.MarketLink.HandicapAway, betweb_openapi_axios_1.MarketLink.HandicapHome);
    if (outcomeHasMarketLink(probWithOutcome, betweb_openapi_axios_1.MarketLink.Unknown)) {
        return name;
    }
    if (outcomeHasMarketLink(probWithOutcome, betweb_openapi_axios_1.MarketLink.Any)) {
        name = `${name} ${getBasketParameterPart(probWithOutcome)}`;
        return name;
    }
    if (outcomeHasMarketLink(probWithOutcome, betweb_openapi_axios_1.MarketLink.HandicapAway, betweb_openapi_axios_1.MarketLink.HandicapHome, betweb_openapi_axios_1.MarketLink.TotalOver, betweb_openapi_axios_1.MarketLink.TotalUnder, betweb_openapi_axios_1.MarketLink.Yes, betweb_openapi_axios_1.MarketLink.No)) {
        name = `${name} 
    ${getBasketMarketLinkPart(probWithOutcome)} 
    ${getBasketParameterPart(probWithOutcome, omitValueParameter)}`;
    }
    return name;
};
exports.getBasketOutcomeName = getBasketOutcomeName;
const outcomeHasMarketLink = (probWithOutcome, ...marketLinks) => marketLinks.some((marketLink) => probWithOutcome.outcomeTypeData.marketLink === marketLink);
// TODO remove after PLAT-372 release
const getOutcomeName = (probWithOutcome, event, isShortNamed) => {
    const { homeCompetitors, awayCompetitors } = (0, events_1.getHomeAwayCompetitors)(event.competitors, event.homeCompetitorIds);
    let { name } = probWithOutcome.outcomeTypeData;
    if (isShortNamed) {
        name = probWithOutcome.outcomeTypeData.shortName;
    }
    return (name
        // eslint-disable-next-line no-template-curly-in-string
        .replaceAll('{$competitor1}', homeCompetitors.map((c) => c.name).join(', '))
        // eslint-disable-next-line no-template-curly-in-string
        .replaceAll('{$competitor2}', awayCompetitors.map((c) => c.name).join(', ')));
};
const getBetOutcomeName = (probWithOutcome, event) => {
    const { homeCompetitors, awayCompetitors } = (0, bets_1.getBetEventHomeAwayCompetitors)(event);
    const name = probWithOutcome.outcomeTypeData.name
        // eslint-disable-next-line no-template-curly-in-string
        .replaceAll('{$competitor1}', homeCompetitors.map((c) => c.name).join(', '))
        // eslint-disable-next-line no-template-curly-in-string
        .replaceAll('{$competitor2}', awayCompetitors.map((c) => c.name).join(', '));
    return name;
};
const marketLinkToLocaleKey = {
    [betweb_openapi_axios_1.MarketLink.Any]: 'market_link_any',
    [betweb_openapi_axios_1.MarketLink.HandicapAway]: 'market_link_handicap_away',
    [betweb_openapi_axios_1.MarketLink.HandicapHome]: 'market_link_handicap_home',
    [betweb_openapi_axios_1.MarketLink.No]: 'market_link_no',
    [betweb_openapi_axios_1.MarketLink.Yes]: 'market_link_yes',
    [betweb_openapi_axios_1.MarketLink.TotalOver]: 'market_link_over',
    [betweb_openapi_axios_1.MarketLink.TotalUnder]: 'market_link_under',
    [betweb_openapi_axios_1.MarketLink.Unknown]: 'market_link_unknown',
};
const parameterToLocaleKey = {
    [betweb_openapi_axios_1.ParameterType.Unknown]: 'parameter_unknown',
    [betweb_openapi_axios_1.ParameterType.Value]: 'parameter_value',
    [betweb_openapi_axios_1.ParameterType.PlayerId]: 'parameter_player_id',
    [betweb_openapi_axios_1.ParameterType.GoalNumber]: 'parameter_goal_number',
    [betweb_openapi_axios_1.ParameterType.PointNumber]: 'parameter_point_number',
    [betweb_openapi_axios_1.ParameterType.GoalsRange]: 'parameter_goals_range',
    [betweb_openapi_axios_1.ParameterType.Bestof]: 'parameter_bestof',
    [betweb_openapi_axios_1.ParameterType.MaxGoals]: 'parameter_maxgoals',
    [betweb_openapi_axios_1.ParameterType.SetNumber]: 'parameter_set_number',
    [betweb_openapi_axios_1.ParameterType.GameNumber]: 'parameter_game_number',
    [betweb_openapi_axios_1.ParameterType.InningNumber]: 'parameter_inning_number',
    [betweb_openapi_axios_1.ParameterType.MapNumber]: 'parameter_map_number',
    [betweb_openapi_axios_1.ParameterType.ExactGoals]: 'parameter_exact_goals',
    [betweb_openapi_axios_1.ParameterType.TimeRange]: 'parameter_time_range',
    [betweb_openapi_axios_1.ParameterType.RoundNumber]: 'parameter_round_number',
    [betweb_openapi_axios_1.ParameterType.HomeScore]: 'parameter_home_score',
    [betweb_openapi_axios_1.ParameterType.AwayScore]: 'parameter_away_score',
    [betweb_openapi_axios_1.ParameterType.HalfNumber]: 'parameter_half_number',
    [betweb_openapi_axios_1.ParameterType.ExtraHalfNumber]: 'parameter_extra_half_number',
    [betweb_openapi_axios_1.ParameterType.QuarterNumber]: 'parameter_quarter_number',
    [betweb_openapi_axios_1.ParameterType.PeriodNumber]: 'parameter_period_number',
    [betweb_openapi_axios_1.ParameterType.FrameNumber]: 'parameter_frame_number',
    [betweb_openapi_axios_1.ParameterType.From]: 'parameter_from',
    [betweb_openapi_axios_1.ParameterType.To]: 'parameter_to',
    [betweb_openapi_axios_1.ParameterType.WinningMargin]: 'parameter_winning_margin',
    [betweb_openapi_axios_1.ParameterType.CompetitorId]: 'parameter_competitor_id',
    [betweb_openapi_axios_1.ParameterType.KillNumber]: 'parameter_kill_number',
    [betweb_openapi_axios_1.ParameterType.LegNumber]: 'parameter_leg_number',
    [betweb_openapi_axios_1.ParameterType.OverNumber]: 'parameter_over_number',
    [betweb_openapi_axios_1.ParameterType.PointRange]: 'parameter_point_range',
    [betweb_openapi_axios_1.ParameterType.WicketNumber]: 'parameter_wicket_number',
    [betweb_openapi_axios_1.ParameterType.DeliveryNumber]: 'parameter_delivery_number',
    [betweb_openapi_axios_1.ParameterType.Number]: 'parameter_number',
    [betweb_openapi_axios_1.ParameterType.Range]: 'parameter_range',
    [betweb_openapi_axios_1.ParameterType.Exact]: 'parameter_exact',
    [betweb_openapi_axios_1.ParameterType.HalfHomeScore]: 'parameter_half_home_score',
    [betweb_openapi_axios_1.ParameterType.HalfAwayScore]: 'parameter_half_away_score',
};
const getBasketMarketLinkPart = (probWithOutcome) => {
    const valueParameter = probWithOutcome.parameters.find((parameter) => parameter.type === betweb_openapi_axios_1.ParameterType.Value);
    if (probWithOutcome.outcomeTypeData.marketLink)
        return i18next_1.default.t(marketLinkToLocaleKey[probWithOutcome.outcomeTypeData.marketLink], { value: valueParameter === null || valueParameter === void 0 ? void 0 : valueParameter.value });
    return '';
};
const getBasketParameterPart = (probWithOutcome, omitValue) => {
    return probWithOutcome.parameters
        .filter((parameter) => ![betweb_openapi_axios_1.ParameterType.HomeScore, betweb_openapi_axios_1.ParameterType.AwayScore].includes(parameter.type) && (omitValue ? parameter.type !== betweb_openapi_axios_1.ParameterType.Value : true))
        .map((parameter) => {
        const value = parameter.type === betweb_openapi_axios_1.ParameterType.PlayerId
            ? parameter.playerName || ''
            : parameter.value;
        return i18next_1.default.t(parameterToLocaleKey[parameter.type], { value });
    })
        .join(', ');
};
//# sourceMappingURL=getBasketOutcomeName.js.map